import { render, staticRenderFns } from "./FooterRight.vue?vue&type=template&id=7e68c534&scoped=true&"
import script from "./FooterRight.vue?vue&type=script&lang=js&"
export * from "./FooterRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e68c534",
  null
  
)

export default component.exports